import { Text } from "react-konva";
import { useTranslation } from "react-i18next";
import { injectGlobal } from "@emotion/css";

const DayOfTheWeekCanvasText: React.FC<{
  Dow: any;
  DowY: number;
  canvasWidth: number;
  canvasHeight: number;
  DowTasks: any;
  weekFontSize: number;
  fontFamilyName: string;
}> = ({
  Dow,
  DowY,
  canvasWidth,
  canvasHeight,
  DowTasks,
  weekFontSize,
  fontFamilyName,
}) => {
  const { t } = useTranslation();

  //ここを動的に変更する
  const TextCSS = injectGlobal`
  @import url("./assets/Fonts/keifont_sub.woff2");
  @import url("./assets/Fonts/CP_Revenge_sub.woff2");
  `;

  return (
    <>
      {Dow.map((value: any, index: number /*平日タスク部分*/) => (
        <Text
          key={index}
          fontSize={canvasWidth / 29}
          x={canvasWidth / 9.1428}
          y={canvasHeight / 6.545 + (canvasHeight / 5.71) * index}
          width={canvasWidth / 2.56}
          text={DowTasks[index]}
          fill="white"
          fontFamily={fontFamilyName}
          css={TextCSS}
        />
      ))}

      {Dow.map((value: any, index: number /*月～金表示部分*/) => (
        <Text
          key={index}
          fontSize={canvasWidth / weekFontSize}
          x={canvasWidth / 80}
          y={DowY + (canvasHeight / 5.71) * index}
          text={t("image.dayOfTheWeekArr", { returnObjects: true })[index]}
          fill="#4b4b4b"
          fontFamily={fontFamilyName}
        />
      ))}
    </>
  );
};

export default DayOfTheWeekCanvasText;
